import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@dugzi/ui/styles.css';
import './app.css';
import { App } from './App';
import { I18nProvider } from '@dugzi/ui';
import { catalogues } from './locales/index.generated';

createRoot(document.getElementById('root')!).render(<StrictMode><I18nProvider catalogues={catalogues} internalPreview={import.meta.env.VITE_INTERNAL_I18N_PREVIEW === 'true'}><App /></I18nProvider></StrictMode>);
